export class LoginInformationModel {

  constructor(
    public username: string,
    public password: string,
    public remember?: boolean
  ) { }
}
